import { Injectable, inject } from '@angular/core';
import { GalleryDto, TenantDto } from '@nusign/picflow-backend-types';
import { Observable, of } from 'rxjs';
import { defaultColorLabels } from '../configs/default-color-labels';
import { extraParamsForCreateGalleryFromPreset } from '../consts';
import { assetStatusOrder } from '../gallery/pipes/asset-status-order.pipe';
import { StateService } from './state.service';
import { ViewGalleryHierarchyService } from './view-gallery-hierarchy.service';

@Injectable({
  providedIn: 'root',
})
export class GalleriesCommonService {
  private state = inject(StateService);
  private galleryHierarchyService = inject(ViewGalleryHierarchyService);
  public galleryPathIsId: Set<string> = new Set();

  public onGetNewGalleries(galleries: GalleryDto[]): Observable<GalleryDto[]> {
    if (!galleries) return of(galleries);
    const tenantIds: Set<string> = new Set();

    galleries.forEach(gallery => {
      if ('password_protected' in gallery) return;
      // galleryPathIsId being set here
      this.galleryPathIsId.add(gallery.id); // what is this?
      if (gallery.unseen_activities !== undefined && !this.state.unseenActivityCountMap.has(gallery.id)) {
        // setting unseen activities for this gallery
        this.state.unseenActivityCountMap.set(gallery.id, gallery.unseen_activities);
        delete gallery.unseen_activities;
      }

      const tenantId = (gallery.tenant as TenantDto)?.id || (gallery.tenant as string);
      if (tenantId) tenantIds.add(tenantId);

      this.fixGallery(gallery);

      if (gallery.parent_gallery) {
        this.galleryHierarchyService.add(gallery.parent_gallery as string, [gallery.id], [gallery.path]);
      }
    });

    return of(galleries);
  }

  /**
   * This function fixes galleries that were created without any contents (params: {})
   */
  fixGallery(gallery: GalleryDto) {
    if ('password_protected' in gallery) return;
    if (!gallery.cover.overlay_color) {
      // Fix for galleries created without any contents in cover:
      gallery.cover = extraParamsForCreateGalleryFromPreset.cover;
    }
    if (gallery.enabled_asset_statuses === null) {
      gallery.enabled_asset_statuses = assetStatusOrder;
    }
    if (gallery.enabled_gallery_statuses === null) {
      gallery.enabled_gallery_statuses = ['no_status'];
    }
    if (gallery.enabled_feedback_options === null) {
      gallery.enabled_feedback_options = ['favourite', 'comment', 'annotation', 'status'];
    }
    if (gallery.color_labels === null) {
      gallery.color_labels = defaultColorLabels;
    }
  }
}
